module.exports = __webpack_public_path__ + "img/鎏金面膜+珍银面膜_05.558f75a2.jpg";